/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

/*
TODO: Content of this file was mainly copeid from frontend/src/components/tooltips/utils.ts!
  It was modified a bit. When dropdownFormPresenter is no longer used (is substituted with ZenObjectsDropdown), remove the aforementoned file.
*/

import { UserRole } from '@/constants/Users';

export const objectsSearchFilter = (searchQuery: string) => ({
  left: 'title',
  op: {
    name: '~',
  },
  right: searchQuery,
});

export const peopleSearchFilter = (searchQuery: string) => ({
  // TODO: Remove duplicate from frontend/src/components/tooltips/utils.ts!
  left: {
    left: 'name',
    op: {
      name: '~',
    },
    right: searchQuery,
  },
  op: {
    name: 'OR',
  },
  right: {
    left: 'email',
    op: {
      name: '~',
    },
    right: searchQuery,
  },
});

export const peopleActiveRolesFilter = {
  left: 'user_role',
  op: {
    name: 'in_array',
  },
  right: [UserRole.Administrator, UserRole.Editor, UserRole.Contributor, UserRole.Reader],
};
